/**
 * Profile URL slugs starting with "qr" are reserved for /qr-* promotional redirects.
 */

export const QR_SLUG_RESERVED_MESSAGE =
  'This URL cannot start with "qr" — that prefix is reserved for printed promotional links.';

/**
 * @param {string} slug raw slug (any casing / may include path noise)
 * @returns {boolean}
 */
export function isQrPromoReservedSlug(slug) {
  if (!slug || typeof slug !== 'string') return false;
  const s = slug.trim().toLowerCase().replace(/^\/+/, '');
  return s.startsWith('qr');
}
